/**
 * Reports web performance metrics to the provided callback function.
 *
 * The callback is only called if it is a function and is passed as the first
 * argument. The callback receives a single argument, an object with the
 * following shape:
 *
 * {
 *   name: string,
 *   id: string,
 *   value: number,
 *   delta: number,
 *   entries: Array<PerformanceEntry>,
 *   valueStr: string
 * }
 *
 * The supported metrics are:
 *
 * - First Contentful Paint (FCP)
 * - First Input Delay (FID)
 * - Largest Contentful Paint (LCP)
 * - Cumulative Layout Shift (CLS)
 * - Time to First Byte (TTFB)
 *
 * See https://web.dev/vitals/ for more information on these metrics.
 * @param {Function} onPerfEntry
 * @returns {void}
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
